var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "closeTrip"
  }, [(_vm.depscloseTrip == false) ? _c('b-card', [_c('div', {
    staticStyle: {
      "margin-bottom": "4rem"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Close Trip")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Trip Listing"
    },
    on: {
      "click": _vm.showCloseTrip
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isBasicInfoLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isBasicInfoLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Trip ID :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tmstripid))]), _vm._v(" "), _c('th', [_vm._v("Trip Status :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tripStatus == 'created' ? 'Created' : _vm.tripStatus == 'start' ? 'Start' : _vm.tripStatus == 'closed' ? 'Closed' : _vm.tripStatus == 'completed' ? "Completed" : ""))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("BA/SR :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tripData.username))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("Vehicle Number :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tripData.vehiclenumber))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Vehicle Close ODO reading(km)")]), _vm._v(" "), _c('td', [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VehicleCloseODOreading),
      expression: "VehicleCloseODOreading"
    }],
    class: {
      'showValue': _vm.ODOhidden == true,
      'showValueNone': _vm.ODOhidden == false,
      'form-control': true
    },
    attrs: {
      "type": "text",
      "min": "1",
      "name": "VehicleCloseODOreading",
      "id": "VehicleCloseODOreading"
    },
    domProps: {
      "value": (_vm.VehicleCloseODOreading)
    },
    on: {
      "keyup": _vm.checkODOKm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.VehicleCloseODOreading = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ODOErr))])], 1)]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset",
      "disabled": _vm.tripStatus == 'closed' || _vm.ODOErr != '' || _vm.disabledLmCloseTrip
    },
    on: {
      "click": _vm.CloseTripConfirmation
    }
  }, [_vm._v("Close Trip")])])])])])])]), _vm._v(" "), _c('div', [_c('b-tabs', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "content-class": "mt-2"
    }
  }, [_c('b-tab', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "title": "First Mile",
      "title-link-class": _vm.linkClass(0)
    },
    on: {
      "click": function($event) {
        _vm.changeTab('firstmile')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isListingLoaded
    },
    on: {
      "update:active": function($event) {
        _vm.isListingLoaded = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n                  Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n                  Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "invoicevconfirmation",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Invoice Confirmation")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', [_vm._v("Scan AWB")]), _vm._v(" "), _c('th', [_vm._v("Invoice Number")]), _vm._v(" "), _c('th', [_vm._v("Invoice Value")]), _vm._v(" "), _c('th', [_vm._v("EWB Number")]), _vm._v(" "), _c('th', [_vm._v("EWB Expiry Date")]), _vm._v(" "), _c('th', [_vm._v("HSN")]), _vm._v(" "), _c('th', {
    attrs: {
      "id": "action"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.firstmileInvoiceData), function(data, index) {
    return _c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (data.awb != '') ? _c('td', [_vm._v(_vm._s(data.awb))]) : _c('td', [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.invoiceAwb[index]),
        expression: "invoiceAwb[index]"
      }],
      class: {
        'refresh': _vm.Loading == true,
        'nochange': _vm.Loading == false,
        'form-control': true
      },
      attrs: {
        "type": "text",
        "name": "invoiceawb",
        "maxlength": 16
      },
      domProps: {
        "value": (_vm.invoiceAwb[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isIntegerOnly($event, index)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.SaveInvoiceData(data, index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.invoiceAwb, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(data.awb))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.invoicenumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.invoicevalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ewbnumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.expirydate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.hsncode))]), _vm._v(" "), (data.awb == '') ? _c('td', [_c('button', {
      staticClass: "-btn btn-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.SaveInvoiceData(data, index)
        }
      }
    }, [_vm._v("Save")])]) : _vm._e()])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "FMAWB",
      "id": "chck1",
      "disabled": _vm.subtabdisabledflag
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Documents InScan")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isAWBScanning
    },
    on: {
      "update:active": function($event) {
        _vm.isAWBScanning = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "16%"
    }
  }, [_vm._v("AWBs to be scanned :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.awbToBeScannedFM))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "21%"
    }
  }, [_vm._v("AWB :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.scanAWB))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Scanned AWB count in trip:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbScannedFM))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Scan AWB")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scanAWB),
      expression: "scanAWB"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "scanAWB",
      "id": "scanAWB"
    },
    domProps: {
      "value": (_vm.scanAWB)
    },
    on: {
      "keyup": _vm.validateAWB,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scanAWB = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.awbErr))])], 1), _vm._v(" "), _c('th', [_vm._v("Number of physical invoices :")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physicalInvoices),
      expression: "physicalInvoices"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "physicalInvoices",
      "id": "physicalInvoices"
    },
    domProps: {
      "value": (_vm.physicalInvoices)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.physicalInvoices = $event.target.value
      }, _vm.validatePhysicalInvoice]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.physicalInvoiceErr))])], 1), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.scanAWBForClose
    }
  }, [_vm._v("Save")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showTable) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Number of Invoices")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Physical invoices")]), _vm._v(" "), _c('th', [_vm._v("Short invoices")]), _vm._v(" "), _c('th', [_vm._v("DWS Inscan")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.firtmileDocumentData), function(data, index) {
    return _c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalinvoice))]), _vm._v(" "), (!_vm.showShipmentDropDown[index]) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalinvoice) + "   "), _c('i', {
      staticClass: "fa fa-edit fa-xs",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "15px",
        "color": "darkgoldenrod",
        "padding": "0px"
      },
      attrs: {
        "title": "Modify Physical Invoice"
      },
      on: {
        "click": function($event) {
          _vm.showEditPhysicalInvoice(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showShipmentDropDown[index]) ? _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.modifyphysicalinvoice),
        expression: "modifyphysicalinvoice"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "text",
        "placeholder": "Physical Invoice",
        "name": "modifyphysicalinvoice"
      },
      domProps: {
        "value": (_vm.modifyphysicalinvoice)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.modifyphysicalinvoice = $event.target.value
        }
      }
    }), _vm._v("\n                                \n                              "), _c('i', {
      staticClass: "fa fa-floppy-o fa-lg",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "25px",
        "color": "rgb(93, 102, 231)",
        "padding": "10px"
      },
      attrs: {
        "title": "Modify Physical Invoice"
      },
      on: {
        "click": function($event) {
          _vm.UpdatePhysicalInvoice(data, index)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.invoiceerr[index]))])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shortinvoice))]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('button', {
      staticClass: "-btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.DWSManualCheck(data)
        }
      }
    }, [_vm._v("Check DWS Inscan")])])], 1)])
  }), _vm._v(" "), (_vm.firtmileDocumentData.length == 0) ? _c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": 4
    }
  }, [_vm._v("Please Scan AWB")])]) : _vm._e()], 2)]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "LMAWB",
      "id": "chck2",
      "disabled": _vm.subtabdisabledflag
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("MPS Inscan")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isMPSScanning
    },
    on: {
      "update:active": function($event) {
        _vm.isMPSScanning = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("To be scanned")]), _vm._v(" "), _c('td', [_vm._v("MPS:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mpsCountFM))]), _vm._v(" "), _c('td', [_vm._v("AWB:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.documentCountFM))]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td'), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Scan Shipment Type")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentType),
      expression: "shipmentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "disabled": _vm.defaultscanflag != 1,
      "id": "AWB",
      "value": "1",
      "name": "shipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.shipmentType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.shipmentType = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "AWB"
    }
  }, [_vm._v("AWB ")]), _vm._v("     \n                                "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentType),
      expression: "shipmentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "disabled": _vm.defaultscanflag != 2,
      "id": "MPS",
      "value": "2",
      "name": "shipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.shipmentType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.shipmentType = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "MPS"
    }
  }, [_vm._v("MPS")]), _vm._v("     \n                              ")])])], 1)])])]), _vm._v(" "), _c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Scan AWB/ MPS")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scanMPS),
      expression: "scanMPS"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "scanMPS",
      "id": "scanMPS"
    },
    domProps: {
      "value": (_vm.scanMPS)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.scanMPS = $event.target.value
      }, _vm.scanMPSForClose]
    }
  })])], 1), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPalletScanCompulsory),
      expression: "isPalletScanCompulsory"
    }]
  }, [_vm._v("Scan Pallet")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPalletScanCompulsory),
      expression: "isPalletScanCompulsory"
    }]
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ScanPalletFM),
      expression: "ScanPalletFM"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ScanPalletFM",
      "id": "ScanPalletFM"
    },
    domProps: {
      "value": (_vm.ScanPalletFM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ScanPalletFM = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.fmScanPalletErr))])], 1), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPalletScanCompulsory),
      expression: "isPalletScanCompulsory"
    }]
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.scanPallet()
      }
    }
  }, [_vm._v("Update")])]), _vm._v(" "), _c('th', [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showDepsCloseTrip('firstmile')
      }
    }
  }, [_vm._v("DEPS")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Scanned AWB/MPS Details")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('label', [_c('b', [_vm._v("AWB :" + _vm._s(_vm.lastMpsAwbScannedData.awb))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('label', [_c('b', [_vm._v("MPS:" + _vm._s(_vm.lastMpsAwbScannedData.mps))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('label', [_c('b', [_vm._v("Count of MPS in AWB:" + _vm._s(_vm.lastMpsAwbScannedData.scannedMPS) + "/" + _vm._s(_vm.lastMpsAwbScannedData.totalAWB))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('label', [_c('b', [_vm._v("Next Hub/Connection:" + _vm._s(_vm.lastMpsAwbScannedData.destinationhubname))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "margin-top": "2%"
    }
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(" AWB Inbounded")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Number of MPS")]), _vm._v(" "), _c('th', [_vm._v("MPS Details")]), _vm._v(" "), _c('th', [_vm._v("Next connection hub")]), _vm._v(" "), _c('th', [_vm._v("Inbound Status")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPalletScanCompulsory),
      expression: "isPalletScanCompulsory"
    }]
  }, [_vm._v("Pallet")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.firstmileMPSData), function(data, index) {
    return _c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.numberofmps))]), _vm._v(" "), _c('td', [(data.total_mps) ? [_c('span', [_vm._v(_vm._s(data.total_mps))]), _vm._v(" "), (data.mpsslot && data.mpsslot.length > 100) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      attrs: {
        "title": "Click to open list of MPS"
      },
      on: {
        "click": function($event) {
          _vm.displayMPS(data)
        }
      }
    }, [_vm._v("+" + _vm._s(data.mpsslot ? data.mpsslot.length - 100 : ''))]) : _vm._e()] : [_c('span', [_vm._v(" ")])]], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', [_vm._v("Completed")]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isPalletScanCompulsory),
        expression: "isPalletScanCompulsory"
      }]
    }, [_vm._v(_vm._s(data.pallet))])])
  }), _vm._v(" "), (_vm.firstmileMPSData.length == 0) ? _c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": 6
    }
  }, [_vm._v("Please Scan AWB/MPS")])]) : _vm._e()], 2)])], 1)])])], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "title": "Last Mile",
      "title-link-class": _vm.linkClass(1)
    },
    on: {
      "click": function($event) {
        _vm.changeTab('lastmile')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isListingLoaded
    },
    on: {
      "update:active": function($event) {
        _vm.isListingLoaded = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n                  Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n                  Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "DeliveredAWBs",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Delivered AWBs")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "deliveredPodForm"
    }
  }, [_c('b-form-fieldset', [_c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "300px"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%",
      "padding-top": "1px",
      "padding-bottom": "1px"
    },
    attrs: {
      "id": "otherinfo"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "4%"
    }
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("WayBill No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v("Field Image")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v("Additional Doc")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Pod QC")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Bad Pod Reason")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Comments")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Shipment Tags")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "text-align": "center"
    }
  }, _vm._l((_vm.podDetail), function(data, index) {
    return _c('tr', {
      key: index,
      class: {
        'error-row': data.error ? data.error : false,
        'success-row': data.documentscanned == 3 ? true : false
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', {
      attrs: {
        "text-align": "left"
      }
    }, [(_vm.checkFieldImage(data)) ? _c('button', {
      staticClass: "btn btn-warning",
      class: {
        'btn-success': data.reviewstatus == true
      },
      attrs: {
        "type": "button",
        "title": "Preview Field Image",
        "id": "setname(index,'viewPod')",
        "name": _vm.setname(index, 'viewPod')
      },
      on: {
        "click": function($event) {
          _vm.viewPodFieldImages(data, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "color": "blue"
      }
    })]) : [_vm._v("NA")]], 2), _vm._v(" "), _c('td', {
      attrs: {
        "text-align": "left"
      }
    }, [(_vm.checkAdditionalDoc(data.additionaldocuments)) ? _c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "type": "button",
        "title": "Preview Additional Document",
        "id": "setname(index,'additionaldocuments')",
        "name": _vm.setname(index, 'additionaldocuments')
      },
      on: {
        "click": function($event) {
          _vm.viewAdditionalImages(data.additionaldocuments, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "color": "blue"
      }
    })]) : [_vm._v("NA")]], 2), _vm._v(" "), _c('td', [_c('b-input-group', [_c('treeselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.validatepodQc(data)),
        expression: " validatepodQc(data)"
      }],
      attrs: {
        "tabindex": "18",
        "multiple": false,
        "max-height": 200,
        "clearable": false,
        "options": _vm.temppodStatusArray,
        "name": _vm.setname(index, 'selectedPodQc'),
        "id": _vm.setname(index, 'selectedPodQc'),
        "placeholder": "Select Pod QC",
        "disabled": _vm.disabledPodQc(data),
        "id": "box",
        "append-to-body": true
      },
      on: {
        "select": function($event) {
          _vm.onChangePodQcStatus($event, index)
        }
      },
      model: {
        value: (data.podqc),
        callback: function($$v) {
          data.podqc = $$v
        },
        expression: "data.podqc"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('deliveredPodForm.selectedPodQc' + index)),
        expression: "errors.has('deliveredPodForm.selectedPodQc'+index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please Select PodQc")])], 1), _vm._v(" "), _c('td', [_c('b-input-group', [_c('treeselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.validateBadPodReason(data)),
        expression: "validateBadPodReason(data)"
      }],
      attrs: {
        "tabindex": "18",
        "multiple": true,
        "max-height": 200,
        "clearable": false,
        "options": _vm.reasonlist,
        "name": _vm.setname(index, 'badpodreason'),
        "id": _vm.setname(index, 'badpodreason'),
        "placeholder": "Select Bad Remarks",
        "id": "box",
        "disabled": _vm.disabledBadPodReason(data, index),
        "append-to-body": true,
        "limit": 1
      },
      on: {
        "select": function($event) {
          _vm.onSelectBadRemark($event, index, data)
        },
        "deselect": function($event) {
          _vm.badResonDeselect(index, $event)
        }
      },
      model: {
        value: (data.badpodreason),
        callback: function($$v) {
          data.badpodreason = $$v
        },
        expression: "data.badpodreason"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('deliveredPodForm.badpodreason' + index)),
        expression: "errors.has('deliveredPodForm.badpodreason'+index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select bad remarks")])], 1), _vm._v(" "), _c('td', [_c('span', {
      directives: [{
        name: "modal",
        rawName: "v-modal",
        value: (data.comments),
        expression: "data.comments"
      }],
      attrs: {
        "name": _vm.setname(index, 'podBadRemarkComments'),
        "id": _vm.setname(index, 'podBadRemarkComments')
      }
    }, [_vm._v(_vm._s(data.comments))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('deliveredPodForm.podBadRemarkComments[index]')),
        expression: "errors.has('deliveredPodForm.podBadRemarkComments[index]')"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please Select Comments")])]), _vm._v(" "), _c('td', [_c('span', {
      directives: [{
        name: "modal",
        rawName: "v-modal",
        value: (data.shipmenttag),
        expression: "data.shipmenttag"
      }],
      attrs: {
        "name": _vm.setname(index, 'shipmenttag'),
        "id": _vm.setname(index, 'shipmenttag')
      }
    }, [_vm._v(_vm._s(data.shipmenttag))])]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.documentscanned != 3),
        expression: "data.documentscanned !=3"
      }],
      staticClass: "btn btn-success",
      attrs: {
        "type": "button",
        "title": "Browse POD Images",
        "name": _vm.setname(index, 'browserPod'),
        "id": _vm.setname(index, 'browserPod'),
        "disabled": data.disableBrowseImageButton,
        "value": data.shippingid
      },
      model: {
        value: (_vm.uploadShippingImage1),
        callback: function($$v) {
          _vm.uploadShippingImage1 = $$v
        },
        expression: "uploadShippingImage1"
      }
    }, [_c('i', {
      staticClass: "fa fa-upload",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.openBrowserUploadModal(data, _vm.selectedPodQc[index], _vm.selectedBadRemarks[index], _vm.podBadRemarkComments[index], index)
        }
      }
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.documentscanned != 3),
        expression: "data.documentscanned !=3"
      }],
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "title": "Capture Images using Camera",
        "name": _vm.setname(index, 'scanPodByCamera'),
        "id": _vm.setname(index, 'scanPodByCamera'),
        "disabled": data.disableCameraImageButton
      },
      on: {
        "click": function($event) {
          _vm.openCapturePhotoModal(data, _vm.selectedPodQc[index], _vm.selectedBadRemarks[index], _vm.podBadRemarkComments[index], index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-camera"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.documentscanned != 3),
        expression: "data.documentscanned !=3"
      }],
      staticClass: "btn btn-info",
      attrs: {
        "type": "button",
        "title": "Capture Image Using Scanner",
        "name": _vm.setname(index, 'scanPodByScanner'),
        "id": _vm.setname(index, 'scanPodByScanner'),
        "disabled": data.disableScannerImageButton
      },
      on: {
        "click": function($event) {
          _vm.openScannerModal(data, _vm.selectedPodQc[index], _vm.selectedBadRemarks[index], _vm.podBadRemarkComments[index], index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-barcode"
    })]), _vm._v(" "), _c('button', {
      staticClass: " btn btn-warning",
      attrs: {
        "type": "button",
        "title": "View Captured POD",
        "name": _vm.setname(index, 'viewHubImage'),
        "id": _vm.setname(index, 'viewHubImage')
      },
      on: {
        "click": function($event) {
          _vm.viewPodHubImages(data, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.documentscanned != 3),
        expression: "data.documentscanned !=3"
      }],
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button",
        "name": _vm.setname(index, 'deletepod'),
        "id": _vm.setname(index, 'deletepod'),
        "title": "Delete POD's"
      },
      on: {
        "click": function($event) {
          _vm.OnClickDeletePod(data, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "UndeliveredAWBs",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Undelivered AWBs")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.Subexpanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": " Sub Expand All"
    },
    on: {
      "click": _vm.SubExpandAll
    }
  }, [_vm._v("\n                        Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.Subexpanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Sub Collapse All"
    },
    on: {
      "click": _vm.SubCollapseAll
    }
  }, [_vm._v("\n                        Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subaccordianTab[1]),
      expression: "subaccordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "DocumentsInScan",
      "id": "Docchck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.subaccordianTab[1]) ? _vm._i(_vm.subaccordianTab[1], null) > -1 : (_vm.subaccordianTab[1])
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        var $$a = _vm.subaccordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.subaccordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.subaccordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.subaccordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "Docchck2"
    }
  }, [_vm._v("Documents InScan")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isAWBScanning
    },
    on: {
      "update:active": function($event) {
        _vm.isAWBScanning = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("AWBs to be scanned :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.awbToBeScannedLM))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "7%"
    }
  }, [_vm._v("AWB :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "22%"
    }
  }, [_vm._v(_vm._s(_vm.scanUndeliveredAWB))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Scanned AWB count :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbScannedLM))])])])]), _vm._v(" "), _c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Scan AWB")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scanUndeliveredAWB),
      expression: "scanUndeliveredAWB"
    }],
    class: {
      'refresh': _vm.Loading == true,
      'nochange': _vm.Loading == false,
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "scanUndeliveredAWB",
      "id": "scanUndeliveredAWB"
    },
    domProps: {
      "value": (_vm.scanUndeliveredAWB)
    },
    on: {
      "keyup": _vm.validateAWB,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scanUndeliveredAWB = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.undeliveredAWBErr))])], 1), _vm._v(" "), _c('th', [_vm._v("Number of physical invoices")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lmPhysicalInvoices),
      expression: "lmPhysicalInvoices"
    }],
    class: {
      'refresh': _vm.Loading == true,
      'nochange': _vm.Loading == false,
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "lmPhysicalInvoices",
      "id": "lmPhysicalInvoices"
    },
    domProps: {
      "value": (_vm.lmPhysicalInvoices)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.lmPhysicalInvoices = $event.target.value
      }, _vm.validatePhysicalInvoice]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.lmPhysicalInvoiceErr))])], 1), _vm._v(" "), _c('th', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.scanAWBForClose
    }
  }, [_vm._v("Save")])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Number of Invoices")]), _vm._v(" "), _c('th', [_vm._v("Physical invoices")]), _vm._v(" "), _c('th', [_vm._v("Short invoices")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.lastmileDocumentData), function(data, index) {
    return _c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalinvoice))]), _vm._v(" "), (!_vm.showShipmentDropDown[index]) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalinvoice) + "   "), _c('i', {
      staticClass: "fa fa-edit",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "19px",
        "color": "darkgoldenrod",
        "padding": "10px"
      },
      attrs: {
        "title": "Modify Physical Invoice"
      },
      on: {
        "click": function($event) {
          _vm.showEditPhysicalInvoice(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showShipmentDropDown[index]) ? _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.modifyphysicalinvoice),
        expression: "modifyphysicalinvoice"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "text",
        "placeholder": "Physical Invoice",
        "name": "modifyphysicalinvoice"
      },
      domProps: {
        "value": (_vm.modifyphysicalinvoice)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.modifyphysicalinvoice = $event.target.value
        }
      }
    }), _vm._v("\n                                    \n                                  "), _c('i', {
      staticClass: "fa fa-floppy-o",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "19px",
        "color": "rgb(93, 102, 231)",
        "padding": "10px"
      },
      attrs: {
        "title": "Modify Physical Invoice"
      },
      on: {
        "click": function($event) {
          _vm.UpdatePhysicalInvoice(data, index)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.invoiceerr[index]))])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shortinvoice))])])
  }), _vm._v(" "), (_vm.lastmileDocumentData.length == 0) ? _c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": 4
    }
  }, [_vm._v("Please Scan AWB")])]) : _vm._e()], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subaccordianTab[2]),
      expression: "subaccordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "MPSInscan",
      "id": "docchck"
    },
    domProps: {
      "checked": Array.isArray(_vm.subaccordianTab[2]) ? _vm._i(_vm.subaccordianTab[2], null) > -1 : (_vm.subaccordianTab[2])
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        var $$a = _vm.subaccordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.subaccordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.subaccordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.subaccordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "docchck"
    }
  }, [_vm._v("MPS Inscan")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isMPSScanning
    },
    on: {
      "update:active": function($event) {
        _vm.isMPSScanning = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("To be scanned")]), _vm._v(" "), _c('td', [_vm._v("MPS:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mpsCountLM))]), _vm._v(" "), _c('td', [_vm._v("AWB:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.documentCountLM))]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td'), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Scan Shipment Type")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lmShipmentType),
      expression: "lmShipmentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "AWB",
      "value": "1",
      "disabled": _vm.defaultscanflag != 1,
      "name": "lmshipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.lmShipmentType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.lmShipmentType = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "AWB"
    }
  }, [_vm._v("AWB ")]), _vm._v("     \n                                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lmShipmentType),
      expression: "lmShipmentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "MPS",
      "value": "2",
      "disabled": _vm.defaultscanflag != 2,
      "name": "lmshipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.lmShipmentType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.lmShipmentType = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "MPS"
    }
  }, [_vm._v("MPS")]), _vm._v("     \n                                  ")])])], 1)])])])])]), _vm._v(" "), _c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Scan AWB/ MPS")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scanUndeliveredMPS),
      expression: "scanUndeliveredMPS"
    }],
    class: {
      'refresh': _vm.Loading == true,
      'nochange': _vm.Loading == false,
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "scanUndeliveredMPS",
      "id": "scanUndeliveredMPS"
    },
    domProps: {
      "value": (_vm.scanUndeliveredMPS)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.scanUndeliveredMPS = $event.target.value
      }, _vm.scanMPSForClose]
    }
  })])], 1), _vm._v(" "), _c('th'), _vm._v(" "), _c('td'), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', {
    attrs: {
      "width": "70%"
    }
  }), _vm._v(" "), _c('th', [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showDepsCloseTrip('lastmile')
      }
    }
  }, [_vm._v("DEPS")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Scanned AWB/MPS Details")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('label', [_c('b', [_vm._v("AWB : " + _vm._s(_vm.lmShipmentType == 1 ? _vm.scanUndeliveredMPS : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('label', [_c('b', [_vm._v("MPS: " + _vm._s(_vm.lmShipmentType == 2 ? _vm.scanUndeliveredMPS : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('label', [_c('b', [_vm._v("Count of MPS in AWB:")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('label', [_c('b', [_vm._v("Next Hub/Connection:" + _vm._s(_vm.lastMpsAwbScannedData.destinationhubname))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(" AWB Inbounded")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Number of MPS")]), _vm._v(" "), _c('th', [_vm._v("MPS Details")]), _vm._v(" "), _c('th', [_vm._v("Inbound Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.lastmileMPSData), function(data, index) {
    return _c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.numberofmps))]), _vm._v(" "), _c('td', [(data.total_mps) ? [_c('span', [_vm._v(_vm._s(data.total_mps))]), _vm._v(" "), (data.mpsslot && data.mpsslot.length > 100) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      attrs: {
        "title": "Click to open list of MPS"
      },
      on: {
        "click": function($event) {
          _vm.displayMPS(data)
        }
      }
    }, [_vm._v("+" + _vm._s(data.mpsslot ? data.mpsslot.length - 100 : ''))]) : _vm._e()] : [_c('span', [_vm._v(" ")])]], 2), _vm._v(" "), _c('td', [_vm._v("Completed")])])
  }), _vm._v(" "), (_vm.lastmileMPSData.length == 0) ? _c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": 4
    }
  }, [_vm._v("Please Scan AWB/MPS")])]) : _vm._e()], 2)])], 1)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedAWB.length > 0),
      expression: "selectedAWB.length > 0"
    }],
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "FTC Cash Memo",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Collectibles")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Trip FTC Cash Collection (INR): " + _vm._s(_vm.cashcollection))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Cash Collected from BA/SR: (INR)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cashcollected),
      expression: "cashcollected"
    }],
    class: {
      'refresh': _vm.Loading == true,
      'nochange': _vm.Loading == false,
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "cashcollected",
      "id": "cashcollected",
      "disabled": _vm.disableflag == true
    },
    domProps: {
      "value": (_vm.cashcollected)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cashcollected = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    class: {
      'refresh': _vm.Loading == true,
      'nochange': _vm.Loading == false
    },
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.disableflag == true
    },
    on: {
      "click": _vm.SaveCollectibles
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "400px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Cash Collected by BA/SR (INR)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedAWB), function(data, index) {
    return _c('tr', {
      key: index,
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.AWB))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Cash))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.istdsapplicable))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      attrs: {
        "for": _vm.setname(index, 'files1')
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px",
        "color": "blue",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Upload Document",
        "aria-hidden": "true"
      }
    }, [_vm._v("Upload Cash Memo")]), _vm._v("  \n                                            ")]), _vm._v(" "), _c('input', {
      attrs: {
        "id": _vm.setname(index, 'files1'),
        "name": _vm.setname(index, 'files1'),
        "type": "file",
        "accept": ".jpeg,.jpg,.png",
        "multiple": "multiple"
      },
      on: {
        "change": function($event) {
          _vm.UploadDocument($event, index)
        }
      }
    }), _vm._v(" "), _c('loader', {
      attrs: {
        "isLoading": _vm.imageLoader
      }
    }), _vm._v(" "), (data.collectibleData.filename == 'png' || data.collectibleData.filename == 'jpg' || data.collectibleData.filename == 'jpeg') ? _c('span', {
      staticStyle: {
        "font-size": "12px",
        "color": "blue",
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true",
        "title": "Open Image"
      },
      on: {
        "click": function($event) {
          _vm.openCollectibleImage(data.collectibleData.filepath.Location)
        }
      }
    }, [_vm._v(" View Image ")]) : _vm._e(), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "100%",
        "max-width": "300px"
      },
      attrs: {
        "id": "myImg",
        "id": 'imgid' + data.collectibleData.filepath.Location
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "modal",
      attrs: {
        "id": 'myModalImg' + data.collectibleData.filepath.Location
      }
    }, [_c('span', {
      staticClass: "close",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Close Image"
      },
      on: {
        "click": function($event) {
          _vm.closemodal('myModalImg' + data.collectibleData.filepath.Location)
        }
      }
    }, [_vm._v("×")]), _vm._v(" "), _c('img', {
      staticClass: "modal-content1",
      attrs: {
        "id": 'img' + data.collectibleData.filepath.Location,
        "src": data.collectibleData.filepath.Location
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "auto",
        "display": "block",
        "width": "80%",
        "max-width": "700px",
        "text-align": "center",
        "color": "#ccc",
        "padding": "10px 0",
        "height": "150px"
      }
    })])], 1)])])
  }))])])], 1)])])])])])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "xl"
    },
    on: {
      "ok": function($event) {
        _vm.showDepartTrip = false
      }
    },
    model: {
      value: (_vm.showDepartTrip),
      callback: function($$v) {
        _vm.showDepartTrip = $$v
      },
      expression: "showDepartTrip"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Depart Trip")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDepartTrip
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("1. Part B Updated")]), _vm._v("  "), _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "22px"
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("2. Loading Completed")]), _vm._v("  "), _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "22px"
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("3. Papers complete")]), _vm._v("  "), _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "22px"
    }
  }), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Trip Departed: Success!!")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right",
      "margin-right": "3px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary1",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Close")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "xl"
    },
    on: {
      "ok": function($event) {
        _vm.showCloseTripModal = false
      }
    },
    model: {
      value: (_vm.showCloseTripModal),
      callback: function($$v) {
        _vm.showCloseTripModal = $$v
      },
      expression: "showCloseTripModal"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Pending AWB/MPS Scan")]), _vm._v(" "), _c('button', {
    staticClass: "closemodal",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeTripModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Trip could not be closed because of incomplete scanning.")]), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AWBArr.length > 0),
      expression: "AWBArr.length > 0"
    }]
  }, [_vm._v("AWB Scanning is pending for following shipments.")]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AWBArr.length > 0),
      expression: "AWBArr.length > 0"
    }],
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Allocation Type")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.AWBArr), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.process))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.allocationtype))])])
  }))]), _vm._v(" "), (_vm.AWBArr.length > 0) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.MPSArr.length > 0),
      expression: "MPSArr.length > 0"
    }]
  }, [_vm._v("MPS Scanning is pending for following shipments.")]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.MPSArr.length > 0),
      expression: "MPSArr.length > 0"
    }],
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Allocation Type")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.MPSArr), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.process))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.allocationtype))])])
  }))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FTCAWB.length > 0),
      expression: "FTCAWB.length > 0"
    }]
  }, [_vm._v("Save Cash Collected By SR For FTC Collectibles.")]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FTCAWB.length > 0),
      expression: "FTCAWB.length > 0"
    }],
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Cash Collection")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Allocation Type")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.FTCAWB), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.cash))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.allocationtype))])])
  }))]), _vm._v(" "), (_vm.FTCAWB.length > 0) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FTCCashmemo.length > 0),
      expression: "FTCCashmemo.length > 0"
    }]
  }, [_vm._v("Pending Cash memo Upload.")]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.FTCCashmemo.length > 0),
      expression: "FTCCashmemo.length > 0"
    }],
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Cash Collection")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Allocation Type")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.FTCCashmemo), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.cash))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.allocationtype))])])
  }))]), _vm._v(" "), (_vm.FTCAWB.length > 0) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pendingInvoice.length > 0),
      expression: "pendingInvoice.length > 0"
    }]
  }, [_vm._v("Pending Invoice Mapping.")]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pendingInvoice.length > 0),
      expression: "pendingInvoice.length > 0"
    }],
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Invoice Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("EWBN")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Allocation Type")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pendingInvoice), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.invoicenumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ewbn))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.allocationtype))])])
  }))])])])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.showMPS = false
      }
    },
    model: {
      value: (_vm.showMPS),
      callback: function($$v) {
        _vm.showMPS = $$v
      },
      expression: "showMPS"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("View MPS")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showMPS = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.modalData) + " "), _c('br')])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false",
      "no-close-on-backdrop": true
    },
    model: {
      value: (_vm.viewpodCommentModal),
      callback: function($$v) {
        _vm.viewpodCommentModal = $$v
      },
      expression: "viewpodCommentModal"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "gray",
      "active": _vm.commentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.commentLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Comments\n                    ")])]), _vm._v(" "), _c('b-form-fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('b-alert', {
    staticClass: "col-lg-12",
    attrs: {
      "show": "",
      "variant": "primary"
    }
  }, [_vm._v("Shipping ID : " + _vm._s(_vm.badRemarkShippingId)), _c('br'), _vm._v("\n                            Remark Selected : " + _vm._s(_vm.currentSelectedRemark) + "\n                        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._v("Enter Comment :  "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.badPodComment),
      expression: "badPodComment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'form-control': true
    },
    staticStyle: {
      "height": "150px"
    },
    attrs: {
      "rows": "8",
      "name": "podcomment",
      "id": "podcomment",
      "placeholder": "Please enter your comment"
    },
    domProps: {
      "value": (_vm.badPodComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.badPodComment = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "infoText"
  }, [_vm._v("Comments should be mandatory")])])]), _vm._v(" "), _c('div', {
    staticClass: "downloadBtn",
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-success btnCancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savePodComment
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btnCancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closePodCommentModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancel")])])], 1)], 1), _vm._v(" "), (_vm.scanDocumentMdlFlag) ? _c('div', [_c('div', {
    staticClass: "custom-modal show-custom-modal"
  }, [_c('div', {
    staticClass: "custom-modal-content ",
    staticStyle: {
      "height": "83vh",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10",
    staticStyle: {
      "overflow-y": "initial"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "text": "Please Wait ..!!",
      "color": "#FF6700",
      "active": _vm.isGetDeviceLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isGetDeviceLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sticky-row",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('b-input-group', {
    staticClass: "col-lg-6"
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.scannerList,
      "name": "scannerList",
      "id": "scannerList",
      "placeholder": "Select Scanner",
      "label": "label",
      "track-by": "id",
      "scroll": true
    },
    on: {
      "select": function($event) {
        _vm.onChangeScanner($event)
      }
    },
    model: {
      value: (_vm.selectedScanner),
      callback: function($$v) {
        _vm.selectedScanner = $$v
      },
      expression: "selectedScanner"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-refresh btn-success btn-sm",
    staticStyle: {
      "margin-left": "5px",
      "padding": "10px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.onClickScannerRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "58%",
      "padding-top": "4px",
      "padding-left": "7px"
    }
  }, [_c('span', {
    staticClass: "helpertooltip"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "helpertooltiptext"
  }, [_vm._v("To install new scanner kindly click on \"Installation Guide\" and follow the process to complete the installation")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://liveb2bxpressclientdoc.s3.ap-south-1.amazonaws.com/b2bcontrolpanel/linux/1.0.0/B2BControlPanelInstallationGuide.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Installation Guide")])])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn-danger btn sm",
    on: {
      "click": _vm.closeScannerModal
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "image-container",
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }, [_c('div', {
    staticClass: "image-container",
    style: ({
      transform: ("rotate(" + _vm.rotation + "deg) scale(" + _vm.zoom + ")")
    })
  }, [(_vm.viewScannedImage) ? _c('img', {
    ref: "previewImage",
    staticClass: "preview-image",
    attrs: {
      "src": _vm.previewScannerImageUrl
    },
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isScannerImageLoading) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])]), _vm._v(" "), (_vm.disabledActionButtonDiv) ? _c('div', {
    staticClass: "icon-group overlay-footer",
    class: {
      'disabled': _vm.disabledActionButtonDiv
    }
  }, [_c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.loadScannedImageByScanner
    }
  }, [_c('i', {
    staticClass: "fa fa-camera camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.rotateScannedImage
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('i', {
    staticClass: "fa fa-search-minus  camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.cancelScannedImage
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(4)])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('b-card-group', {
    staticStyle: {
      "height": "80vh",
      "overflow-y": "scroll",
      "text-align": "center"
    },
    attrs: {
      "deck": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "View Image",
      "header-tag": "header"
    }
  }, [_c('div', _vm._l((_vm.selectedPodImagesByScanner), function(data, index) {
    return _c('div', {
      staticClass: "image-container_view"
    }, [_c('img', {
      staticClass: "styled-image",
      attrs: {
        "src": data,
        "alt": "Your Image"
      },
      on: {
        "click": function($event) {
          _vm.viewScannerImage(data)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times-circle close-icon",
      on: {
        "click": function($event) {
          _vm.removeScannerCapturedImage(index)
        }
      }
    }), _c('br')])
  })), _vm._v(" "), (_vm.viewScannerImageUploadButton) ? _c('footer', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.uploadScannerCapturedBinaryImage()
      }
    }
  }, [_vm._v("Upload Image")])]) : _vm._e()])], 1)], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.uploadBrowsePodImageMdlFlag) ? _c('div', [_c('div', {
    staticClass: "custom-modal show-custom-modal"
  }, [_c('div', {
    staticClass: "custom-modal-content ",
    staticStyle: {
      "height": "83vh",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10",
    staticStyle: {
      "overflow-y": "initial"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "text": "Please wait !!",
      "color": "#FF6700",
      "active": _vm.isScannerImageLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isScannerImageLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui"
  }, [_c('div', {
    staticClass: "sticky-row",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "files",
    attrs: {
      "id": "selectPodImage",
      "name": "selectPodImage",
      "multiple": "",
      "type": "file",
      "accept": "image/*",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.BrowsePodImage
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uploadform.BrowsePodImage')),
      expression: "errors.has('uploadform.BrowsePodImage')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Choose\n                      file\n                      to upload")])]), _vm._v(" "), _c('button', {
    staticClass: "btn-danger btn sm",
    on: {
      "click": _vm.closeBrowseUploadModal
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "image-container",
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }, [(_vm.previewImageUrl) ? _c('img', {
    ref: "previewImage",
    staticClass: "preview-image",
    style: ({
      transform: ("rotate(" + _vm.rotation + "deg) scale(" + _vm.zoom + ")")
    }),
    attrs: {
      "src": _vm.previewImageUrl,
      "id": "img",
      "alt": "No Image"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), (_vm.disabledActionButtonDiv) ? _c('div', {
    staticClass: "icon-group overlay-footer",
    class: {
      'disabled': _vm.disabledActionButtonDiv
    }
  }, [_c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.rotateScannedImage
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('i', {
    staticClass: "fa fa-search-minus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(8)])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('b-card-group', {
    staticStyle: {
      "height": "80vh",
      "overflow-y": "scroll",
      "text-align": "center"
    },
    attrs: {
      "deck": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "View Image",
      "header-tag": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, _vm._l((_vm.selectedPodImage), function(data, index) {
    return _c('div', {
      staticClass: "image-container_view"
    }, [_c('img', {
      staticClass: "styled-image",
      attrs: {
        "src": data,
        "alt": "Your Image"
      },
      on: {
        "click": function($event) {
          _vm.viewImage(data)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times-circle close-icon",
      on: {
        "click": function($event) {
          _vm.removeImage(index)
        }
      }
    }), _c('br')])
  })), _vm._v(" "), (_vm.viewBrowseImageUploadButton) ? _c('footer', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.uploadBrowsedFilesInS3()
      }
    }
  }, [_vm._v("Upload Image")])]) : _vm._e()])], 1)], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.capturePhotoMdlFlag) ? _c('div', [_c('div', {
    staticClass: "custom-modal show-custom-modal"
  }, [_c('div', {
    staticClass: "custom-modal-content ",
    staticStyle: {
      "height": "83vh",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10",
    staticStyle: {
      "overflow-y": "initial"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "text": "Please wait ..!!",
      "color": "#FF6700",
      "active": _vm.isCameraImageLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isCameraImageLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui"
  }, [_c('div', {
    staticClass: "sticky-row",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('b-input-group', {
    staticClass: "col-lg-5"
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.printerList,
      "name": "printerList",
      "id": "printerList",
      "placeholder": "Select Camera ",
      "label": "label",
      "track-by": "deviceId",
      "scroll": true
    },
    on: {
      "select": function($event) {
        _vm.onChangeCamera($event)
      }
    },
    model: {
      value: (_vm.selectedCamera),
      callback: function($$v) {
        _vm.selectedCamera = $$v
      },
      expression: "selectedCamera"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-refresh btn-success btn-sm",
    staticStyle: {
      "margin-left": "5px",
      "padding": "10px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.onClickCameraRefresh
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn-danger btn sm",
    on: {
      "click": _vm.closeTakePhotoModal
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "image-container",
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }, [(!_vm.imageData.image) ? _c('video', {
    ref: "video",
    staticClass: "camera-stream"
  }) : _c('img', {
    staticClass: "camera-stream",
    style: ({
      transform: ("rotate(" + (_vm.imageData.image_orientation) + "deg) scale(" + _vm.zoom + ")")
    }),
    attrs: {
      "src": _vm.imageData.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), (_vm.disabledActionButtonDiv) ? _c('div', {
    staticClass: "icon-group overlay-footer"
  }, [_c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.captureCameraImage
    }
  }, [_c('i', {
    staticClass: "fa fa-camera camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.rotateImage
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('i', {
    staticClass: "fa fa-search-minus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.cancelCameraCapturedImage
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(13)])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('b-card-group', {
    staticStyle: {
      "height": "80vh",
      "overflow-y": "scroll",
      "text-align": "center"
    },
    attrs: {
      "deck": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "View Image",
      "header-tag": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, _vm._l((_vm.selectedCameraCapturedPodImage), function(data, index) {
    return _c('div', {
      staticClass: "image-container_view"
    }, [_c('img', {
      staticClass: "styled-image",
      attrs: {
        "src": data,
        "alt": "Your Image"
      },
      on: {
        "click": function($event) {
          _vm.viewCameraImage(data)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times-circle close-icon",
      on: {
        "click": function($event) {
          _vm.removeCameraCapturedImage(index)
        }
      }
    }), _c('br')])
  })), _vm._v(" "), (_vm.viewCameraImageUploadButton) ? _c('footer', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.uploadCameraCapturedBinaryImage()
      }
    }
  }, [_vm._v("Upload Image")])]) : _vm._e()])], 1)], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.viewUploadedPodImages) ? _c('div', [_c('div', {
    staticClass: "custom-modal show-custom-modal"
  }, [_c('div', {
    staticClass: "custom-modal-content ",
    staticStyle: {
      "height": "83vh",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10",
    staticStyle: {
      "overflow-y": "initial"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "text": "Please wait image is scanning",
      "color": "#FF6700",
      "active": _vm.viewCapturedPodLoader
    },
    on: {
      "update:active": function($event) {
        _vm.viewCapturedPodLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui"
  }, [_c('div', {
    staticClass: "sticky-row",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "file-upload"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-danger btn sm",
    on: {
      "click": _vm.closeViewUploadedImageModal
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "image-container",
    class: {
      'loading': _vm.isScannerImageLoading
    },
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }, [(_vm.viewCapturedPodsImageSrc) ? _c('img', {
    ref: "previewImage",
    staticClass: "preview-image",
    style: ({
      transform: ("rotate(" + _vm.rotation + "deg) scale(" + _vm.zoom + ")")
    }),
    attrs: {
      "src": _vm.viewCapturedPodsImageSrc,
      "id": "img",
      "alt": "No Image"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), (_vm.disabledActionButtonDiv) ? _c('div', {
    staticClass: "icon-group overlay-footer"
  }, [_c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.rotateScannedImage
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('i', {
    staticClass: "fa fa-search-minus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(16)])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('b-card-group', {
    staticStyle: {
      "height": "83vh",
      "overflow-y": "scroll",
      "text-align": "center"
    },
    attrs: {
      "deck": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "Selected POD's",
      "header-tag": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, _vm._l((_vm.viewUploadedHubImages), function(data, index) {
    return _c('div', {
      staticClass: "image-container_view"
    }, [_c('img', {
      staticClass: "styled-image",
      attrs: {
        "src": data,
        "alt": "Your Image"
      },
      on: {
        "click": function($event) {
          _vm.viewSinglePodImage(data)
        }
      }
    })])
  }))])], 1)], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.depscloseTrip == true) ? _c('div', [_c('deps-close-trip', {
    attrs: {
      "parentObj": _vm.closeTripData
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('section', [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.podImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.podImage
    }
  }, [_c('span', {
    staticClass: "closemodel",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close Image"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.podImage)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.podImage,
      "src": _vm.podImage
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Scan Image")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Rotate")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom In")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom Out")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Cancel")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "selectPodImage"
    }
  }, [_c('a', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "font-size": "15px",
      "color": "white !important",
      "font-weight": "bold"
    },
    attrs: {
      "title": "Choose File to Upload"
    }
  }, [_vm._v("Choose\n                        File "), _c('i', {
    staticClass: "fa fa-upload",
    staticStyle: {
      "color": "#fff"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Rotate")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom In")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom Out")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Take Picture")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Rotate")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom In")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom Out")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Cancel")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Rotate")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom In")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom Out")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5adf96dc","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/closeTrip/closeTrip.component.html
// module id = 1346
// module chunks = 3